var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"storage-setting"},[_c('div',{staticClass:"ls-card"},[_c('div',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.info.auth_status == 1 ? '授权成功' : '授权失败')+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }